import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VacationManagementService } from './vacation-management.service';

@NgModule({
  imports: [CommonModule],
  providers: [VacationManagementService],
})
export class VacationManagementModule {}
